'use strict';

const $body = $('body');
const formValidation = require('core/components/formValidation');
const clientSideValidation = require('core/components/clientSideValidation');

const $registrationForm = $('form.jil-registration');

module.exports = {
  init: function () {
    //  clientSideValidation.init();
    $registrationForm.on('bouncerFormValid', function (e) {
      e.preventDefault();

      $.spinner().start();
      clientSideValidation.functions.clearFormErrors($registrationForm);
      const submitBtn = $registrationForm.find('button[type="submit"]');
      submitBtn.attr('disabled', 'disabled');
      $.post({
        url: $registrationForm.attr('action'),
        dataType: 'json',
        data: $registrationForm.serialize(),
        success: function (data) {
          if (!data.success) {
            submitBtn.removeAttr('disabled');
            formValidation($registrationForm, data);
            $.spinner().stop();
            clientSideValidation.functions.scrollToError($registrationForm);
            if( $registrationForm.parents('.modal-content').length > 0) {
               $registrationForm.parents('.modal-content').animate(
                {
                  scrollTop:  $registrationForm.find('.is-invalid,.-invalid').first().offset().top - 25,
                },
                500
              );
            }
            $('.js-birthday-input').val(`${document.querySelector('.js-day').value}/${document.querySelector('.js-month').value}/${document.querySelector('.js-year').value}`);
            let hasNewsletterInterestError = Object.keys(data.fields).find((fieldName) => { return fieldName.indexOf('genderCollection') !== -1});
            if(hasNewsletterInterestError) {
              $('.js-newsletter-interest-required').removeClass('d-none').addClass('-invalid');
            }
            else {
              $('.js-newsletter-interest-required').removeClass('-invalid');
            }
          } else {
            $body.trigger('user:registered');
            $body.trigger('customer:updateAttributes');
            window.location = data.redirectUrl;
          }
        },
        error: function (err) {
        
          submitBtn.removeAttr('disabled');
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          }

          $.spinner().stop();
        },
      });

      return false;
    });
  },

};
